import React, { useEffect, useRef } from "react";
import somNotificacaoArquivo from "../assets/sounds/notificacao.wav";

export function useAlertaSonoro({ listaFiltrada, filtro, usuarioLogado, STATUS_COR_AMARELA, STATUS_COR_VERMELHA }) {
    const sleepTimeoutRef = useRef(null);
    const intervaloNotificacaoRef = useRef(null);

    useEffect(() => {
        // cleanup sempre antes de recriar
        limparTimers();

        const doisMinutos = 1000 * 60 * 2;

        sleepTimeoutRef.current = setTimeout(() => {
            const agora = new Date();

            const mes = agora.getMonth() + 1;
            const hora = agora.getHours();
            const minutos = agora.getMinutes();

            let horarioValido = false;

            if ((mes >= 11 || mes <= 2) && ((hora > 7 && hora < 18) || (hora === 7 && minutos >= 30) || (hora === 18 && minutos === 0))) {
                horarioValido = true;
            } else if (mes >= 3 && mes <= 5 && ((hora > 8 && hora < 17) || (hora === 8 && minutos >= 30) || (hora === 17 && minutos === 0))) {
                horarioValido = true;
            } else if (mes >= 6 && mes <= 10 && ((hora >= 9 && hora < 17) || (hora === 17 && minutos === 0))) {
                horarioValido = true;
            }

            const leiturasComErro = listaFiltrada.find((item) => {
                const nuvemOuChuvaValidada = hora < 9 || (hora === 17 && minutos > 0) || hora > 17 ? !item.nuvemOuChuva : true;

                return nuvemOuChuvaValidada && !item.status_visualizado && !filtro.id_agrupador && [STATUS_COR_AMARELA, STATUS_COR_VERMELHA].includes(item.corStatus);
            });

            if (leiturasComErro && horarioValido && usuarioLogado.emitir_alerta_sonoro) {
                intervaloNotificacaoRef.current = setInterval(async () => {
                    try {
                        const audio = new Audio(somNotificacaoArquivo);
                        await audio.play();
                    } catch (e) {
                        console.log("Erro ao tocar som", e);
                    }
                }, 3000);
            }
        }, doisMinutos);

        return limparTimers;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtro, usuarioLogado, JSON.stringify(listaFiltrada)]);

    function limparTimers() {
        if (sleepTimeoutRef.current) {
            clearTimeout(sleepTimeoutRef.current);
            sleepTimeoutRef.current = null;
        }
        if (intervaloNotificacaoRef.current) {
            clearInterval(intervaloNotificacaoRef.current);
            intervaloNotificacaoRef.current = null;
        }
    }
}
